import { makeAutoObservable } from 'mobx'

export class HomeStore {
  timesClicked = 0
  names = [] as string[]

  constructor() {
    makeAutoObservable(this)
  }

  addName(name: string){
    this.names.push(name)
  }


  increment() {
    this.timesClicked++
  }
}
